import styled from "styled-components";



// Переключатель языков — по содержимому: во flex-колонке он иначе растягивается на всю ширину.
export const LangRow = styled.div`
    display: flex;
`;


